import React from 'react';
import services from 'core/services';
import PropTypes from 'prop-types';

import { withLocale } from 'core/decorators';

const serialize = services.utils.serialize;

const currenciesStyle = {
  margin: 0, 
  fontSize: ".5rem"
}

const Price = function({price, unit, hasExtension, t, lng, round, ...rest}) {
  return (
    <React.Fragment>
			<span {...rest}>{serialize.parseCurrency(price, unit, lng, round)}</span>
			{hasExtension ? <span style={currenciesStyle}> {t('common:currencies:toman')}</span> : null }
    </React.Fragment>
  );
};

Price.defaultProps = {
  hasExtension: true,
  // ceil: upward | floor: downward | round: nearest
  round: 'ceil',
};

Price.propTypes = {
  price: PropTypes.number,
  unit: PropTypes.string,
  hasExtension: PropTypes.bool,
  round: PropTypes.string,
};

export default withLocale()(Price);
